const MINUTES = 60 * 1000
const HOURS = 60 * MINUTES
export const STALE_TIME = 24 * HOURS
